import {
  CheckBox,
  FormInputGroupLayout,
  InfoBlock,
  InfoBlockLayout,
  InfoBlockStatus,
  InputFormCallout,
  InputFormCalloutProps,
} from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";

export const Fields = {
  LocalEnabled: "localEnabled",
  SparseEnabled: "sparseEnabled",
};
export interface StoragePanelConfigProps extends
  Pick<InputFormCalloutProps, "title" | "targetId" | "onClose" | "onSubmit">
{
  defaultValue?: { localEnabled: boolean, sparseEnabled: boolean },
}

export const StoragePanelConfig = ({
  defaultValue,
  title,
  onClose,
  onSubmit,
  targetId,
}: StoragePanelConfigProps): JSX.Element => (
  <InputFormCallout
    layout={FormInputGroupLayout.WIDE}
    title={title || ""}
    targetId={targetId}
    onClose={onClose}
    onSubmit={onSubmit}
  >
    <CheckBox
      fieldName={Fields.SparseEnabled}
      defaultValue={defaultValue?.sparseEnabled}
      label={Messages.labels.allocateStorageSparse()}
      tooltip={Messages.hints.allocateStorageSparse()}
    />
    <CheckBox
      fieldName={Fields.LocalEnabled}
      defaultValue={defaultValue?.localEnabled}
      label={Messages.labels.allocateStorageLocal()}
      tooltip={Messages.hints.allocateStorageLocal()}
    />
    <span style={{ marginBottom: "10px" }}>
      <InfoBlock
        message={Messages.createCommon.storageNoChangeAfterVMCreation()}
        messageType={InfoBlockStatus.INFO}
        infoLayout={InfoBlockLayout.Compact}
      />
    </span>
  </InputFormCallout>
);
